<ds-overview-section
  [loading]="dataLoading$ | async"
  [spinnerTextPath]="'billing.overview.spinnerText'"
  class="overview-section--billing"
  [disableDefaultClass]="navFromBillDash || navFromOverview"
  [sectionHeading]="sectionTitle"
>
  <ds-overview-section-header-link>
    @if ((billAccountCards$ | async).length > 1 && !navFromBillDash) {
      <a
        class="overview-header-link font-size-1 font-weight-semibold"
        [dsRouterLink]="[billingPaths.BILLING_SECTION_PAGE]"
        ><span dsContent [contentPath]="'billing.allBills'"></span>
        <img src="/assets/images/chevron-right-thick.svg" />
      </a>
    }
  </ds-overview-section-header-link>

  @if ((dataLoading$ | async) === false) {
    <ds-overview-section-content>
      @if (romeFeatureBanner && hasMultiBillAccForRome) {
        <div class="rome-banner">
          <div>
            <span class="icon-amfam-alert-triangle-fill-1"></span>
            <span
              class="banner-heading"
              dsContent
              [contentPath]="'billing.romeBanner.heading'"
            ></span>
          </div>
          <div class="banner-content">
            <div dsContent [contentPath]="'billing.romeBanner.payFor'"></div>
            <div>
              <ul class="banner-list">
                @for (bannerListItem of romeBannerList; track bannerListItem) {
                  <li>{{ bannerListItem }}</li>
                }
              </ul>
            </div>
            <div dsContent [contentPath]="'billing.romeBanner.notDuplicate'"></div>
            <div
              class="banner-question"
              dsContent
              [contentPath]="'billing.romeBanner.question'"
            ></div>
            <div dsContent [contentPath]="'billing.romeBanner.answer'"></div>
            <a
              (click)="openRomeModal()"
              class="link"
              dsContent
              [contentPath]="'billing.romeBanner.modalLink'"
            ></a>
          </div>
        </div>
      }
      <div class="row borderless tiles" data-cy="billingOverviewTileContainer">
        @for (card of billAccountCards$ | async | slice: 0 : 8; track card) {
          <div class="column pad-bottom twelve md-four --billing" data-cy="billingOverviewTiles">
            <ds-bill-account-card
              [billAccountCard]="card"
              [showAccountNumberAndNickname]="isMyAccountAdmin"
              (actionButtonEvent)="deriveRoutingPath($event)"
              (viewAccountEvent)="viewAccount($event)"
            >
            </ds-bill-account-card>
          </div>
        }
      </div>
      <ds-payment-method-modal
        [paymentMethodAddEditConfig]="paymentMethodAddEditConfig$ | async"
        [showTryAgainButton]="true"
        (paymentMethodAddEditCompleteEvent)="paymentMethodAddEditComplete()"
      >
      </ds-payment-method-modal>
      <!-- // if the user does not have any bills setup -->
      @if ((billAccountCards$ | async)?.length === 0 && (billAccountsError$ | async) === false) {
        <div class="row borderless tiles" data-cy="noBillingAccountsMessage">
          <div class="column pad-bottom twelve md-four --billing">
            <ds-tile class="info-tile">
              <div class="tile-heading" tile-heading>
                <b dsContent [contentPath]="'billing.noBillingAccountsMessage'"></b>
              </div>
              <div class="tile-content" tile-content>
                <div>
                  <p dsContent [contentPath]="'billing.manageAccountsElectronicallyText'"></p>
                </div>
              </div>
              <div tile-cta class="tile-cta">
                <button
                  ds-button
                  [dsRouterLink]="[billingPaths.BILLING_SECTION_PAGE]"
                  [attr.aria-label]="'Add Account'"
                  dsContent
                  [contentPath]="'billing.addAccountButton'"
                ></button>
              </div>
            </ds-tile>
          </div>
        </div>
      }
      @if (billAccountsError$ | async) {
        <ds-overview-card>
          <ds-overview-card-content>
            <div class="card_container alert" data-cy="billingOverviewbillAccountsError">
              <div class="card_container">
                <div class="card-header">
                  <div class="card-heading-wrapper">
                    <div class="policy-overview-card__heading">
                      <div class="heading-container">
                        <div class="heading-text">
                          <p class="heading-text-nickname">
                            <b dsContent [contentPath]="'billing.somethingWentWrongMessage'"></b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-content">
                  <div>
                    <p
                      class="pad-bottom-20"
                      dsContent
                      [contentPath]="'billing.incompleteRequestMsg'"
                    ></p>
                    <p>
                      <span dsContent [contentPath]="'billing.pleaseCallMessage'"></span>
                      <span dsPartnerContent [brandContent]="'selectPrettyCusCareNumber'"></span>
                      <span dsContent [contentPath]="'billing.tryLaterMessage'"></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ds-overview-card-content>
        </ds-overview-card>
      }
    </ds-overview-section-content>
  }
</ds-overview-section>

<ds-alert-modal
  [config]="silentRegistrationAllFailedError"
  (primaryEvent)="closeSilentRegistrationErrorModal()"
>
</ds-alert-modal>

<ds-silent-registration-error-modal> </ds-silent-registration-error-modal>

<ds-rome-bill-payment-faq-modal [id]="romeBannerPaymentModalId"></ds-rome-bill-payment-faq-modal>
